export enum ActivityFeedKeys {
    MerchantGroupTeam = 'merchant-group-${0}'
}